import PropTypes from "prop-types"
import React, { useEffect } from "react"
import withRouter from "components/Common/withRouter"
//redux
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { logout } from "store/features/auth/authSlice"

const Logout = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(logout())
    navigate("/login")
  }, [dispatch, navigate])

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
